(() => {
  document.querySelectorAll('[data-predictive-input]').forEach((input) => {
    const panel = document.getElementById(input.getAttribute('aria-controls'));
    if (!panel) return;
    let timer;
    let controller;
    let generation = 0;
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      const request = ++generation;
      close();
      if (query.length < 2) return;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(window.theme.predictiveSearchUrl, window.location.origin);
          url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '5', section_id: 'predictive-search' });
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (generation !== request) return;
          const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
          if (!results) return;
          panel.innerHTML = results.innerHTML;
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch { if (generation === request) close(); }
      }, 200);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' && !panel.hidden) { event.preventDefault(); panel.querySelector('a')?.focus(); }
      if (event.key === 'Escape') { generation++; controller?.abort(); close(); }
    });
    panel.addEventListener('keydown', (event) => {
      const links = [...panel.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); close(); input.focus(); }
      if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(index + 1, links.length - 1)]?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) input.focus(); else links[index - 1].focus(); }
    });
    document.addEventListener('click', (event) => { if (!panel.contains(event.target) && event.target !== input) close(); });
    input.form.addEventListener('focusout', () => setTimeout(() => { if (!input.form.contains(document.activeElement)) close(); }, 0));
  });
})();
